;
define("notifications.tpl", function(){});

